import { defineAsyncComponent } from 'vue'

export const ModalSignIn = defineAsyncComponent(() => import('../ModalSignIn/ModalSignIn.vue'))
